import React from 'react';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import CheckboxFilter from '@spa/shared/components/Filters/Checkbox';
import Group from '@spa/shared/components/Filters/Group';
import { GroupItemsContainer } from './styles';

const restrictionsOccupation = 'restrictions-occupation';
const rules = 'rules';
const restrictionsOccupancy = 'restrictions-occupancy';

const filters = {
  [restrictionsOccupation]: [['postgraduate', 'undergraduate'], ['professional-placement']],
  [rules]: ['smoking-allowed', 'pets-allowed', 'overnight-guests-allowed'],
  [restrictionsOccupancy]: ['couples']
};

const SuitableFor = ({ fields, onChangeEventHandler, onChangeEventForceArrayHandler }) => {
  const { t } = useTranslation('translations');

  const onRestrictionsOccupancyChange = event => onChangeEventForceArrayHandler(event);

  return (
    <Group title={t('filters.sections.suitable_for')}>
      <GroupItemsContainer>
        {filters[restrictionsOccupation].map(value => (
          <CheckboxFilter
            key={value}
            name={restrictionsOccupation}
            value={value}
            onChange={onChangeEventHandler}
            selected={
              fields['restrictions-occupation'] && value.every(value => fields[restrictionsOccupation].includes(value))
            }
            label={t(`filters.labels.${restrictionsOccupation}.${value}`)}
          />
        ))}

        {filters[rules].map(value => (
          <CheckboxFilter
            key={value}
            name={rules}
            value={value}
            onChange={onChangeEventHandler}
            selected={fields[rules] && fields[rules].includes(value)}
            label={t(`filters.labels.rules.${value}`)}
          />
        ))}

        {filters[restrictionsOccupancy].map(value => (
          <CheckboxFilter
            key={value}
            name={restrictionsOccupancy}
            value={value}
            onChange={onRestrictionsOccupancyChange}
            selected={fields[restrictionsOccupancy] && fields[restrictionsOccupancy].includes(value)}
            label={t(`filters.labels.${restrictionsOccupancy}.${value}`)}
          />
        ))}
      </GroupItemsContainer>
    </Group>
  );
};

SuitableFor.propTypes = {
  fields: PropTypes.object.isRequired,
  onChangeEventHandler: PropTypes.func.isRequired,
  onChangeEventForceArrayHandler: PropTypes.func.isRequired
};

export default SuitableFor;
